import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
var application = new Swiper(".section8 .mySwiper", {
    slidesPerView: 2.875,
    spaceBetween: '1.68%',
    navigation: {
        nextEl: ".section8  .swiper-button-next",
        prevEl: ".section8  .swiper-button-prev",
    },
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 2.875,
        spaceBetween: '1.68%',
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 2,
        spaceBetween: '1.68%',
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        spaceBetween: 0,
      }
    } 
});

$(".section9 ul li .ask").click(function() {
    $(this).parent().toggleClass('active');
    $(this).parent().find(".answer").slideToggle();
})